module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('i', [_vm._v("If the elephant vanished")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('i', [_vm._v("the loss to human laughter")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('i', [_vm._v("wonder and tenderness would")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('i', [_vm._v("be a calamity")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "dedication2"
  }, [_vm._v("— V. S. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITCHETT")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_vm._v("reviewing "), _c('i', [_vm._v("The Roots of Heaven")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41b49f9b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Dedication.vue
// module id = 72
// module chunks = 0